import BottomMenuBar from "./bottom-menu-bar";

export default BottomMenuBar;